// removed by extract-text-webpack-plugin
module.exports = {"date":"_3J_ypO4bB8uizxf31E9sg1","intro":"_34r3nwm5z6R0NJltpD8BkB","photos":"_2WWws_kiUq2jwZu0QJhoxa"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolCamps/SchoolCamps.scss
// module id = 881
// module chunks = 0